(() => {
  let lastTrigger = null;
  let openModal = null;

  const lockScroll = () => {
    const gap = window.innerWidth - document.documentElement.clientWidth;
    if (gap > 0) document.body.style.paddingRight = gap + 'px';
    document.body.classList.add('aeya-uds-modal-open');
  };

  const unlockScroll = () => {
    document.body.classList.remove('aeya-uds-modal-open');
    document.body.style.paddingRight = '';
  };

  const close = () => {
    if (!openModal) return;
    openModal.setAttribute('hidden', '');
    unlockScroll();
    if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
    openModal = null;
    lastTrigger = null;
  };

  const open = (modal, trigger) => {
    if (openModal) close();
    openModal = modal;
    lastTrigger = trigger || null;
    modal.removeAttribute('hidden');
    lockScroll();
    const focusable = modal.querySelector('.aeya-uds-modal__close');
    if (focusable) focusable.focus();
  };

  const initModals = (root) => {
    root.querySelectorAll('[data-uds-modal]').forEach((modal) => {
      if (modal.dataset.udsPortaled) return;
      modal.dataset.udsPortaled = 'true';
      document.body.appendChild(modal);
      modal.querySelectorAll('[data-uds-close]').forEach((el) => {
        el.addEventListener('click', close);
      });
    });
  };

  const initSection = (root) => {
    if (root.dataset.udsReady) return;
    root.dataset.udsReady = 'true';

    const track = root.querySelector('[data-track]');
    const prev = root.querySelector('[data-dir="prev"]');
    const next = root.querySelector('[data-dir="next"]');
    if (track && prev && next) {
      const page = () => {
        const first = track.querySelector('.aeya-uds__item');
        if (!first) return track.clientWidth;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 16;
        return first.getBoundingClientRect().width + gap;
      };
      const updateState = () => {
        const max = track.scrollWidth - track.clientWidth - 1;
        prev.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft >= max;
      };
      prev.addEventListener('click', () => track.scrollBy({ left: -page(), behavior: 'smooth' }));
      next.addEventListener('click', () => track.scrollBy({ left: page(), behavior: 'smooth' }));
      track.addEventListener('scroll', updateState, { passive: true });
      window.addEventListener('resize', updateState);
      updateState();
    }

    root.querySelectorAll('[data-uds-open]').forEach((trigger) => {
      const id = trigger.getAttribute('data-uds-open');
      trigger.addEventListener('click', () => {
        const modal = document.getElementById(id);
        if (modal) open(modal, trigger);
      });
    });

    initModals(root);
  };

  const boot = () => document.querySelectorAll('.aeya-uds').forEach(initSection);

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });

  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target.querySelector('.aeya-uds');
    if (root) initSection(root);
  });
})();
